import Constants from '@usas/ui-web/utils/Constants';
import { PreCompHttpHelper, BASIC_INITIAL_STATE, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  dataAsOptionsWithNames: []
};

const getPreCompInstructionHours = (state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const url = `/InstructionHours`;
    PreCompHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          arrayData.unshift({ instructionHoursId: Constants.DEFAULT_ID, instructionHoursDescription: '--' });
          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            dataAsOptionsWithNames: arrayData.map(x => { return { id: x.instructionHoursId, name: x.instructionHoursDescription } }),
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

const PreCompInstructionHoursData = {
  INITIAL_STATE,
  getPreCompInstructionHours
};

export default PreCompInstructionHoursData;